var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"eager":true,"close-on-content-click":false,"transition":"slide-x-transition","bottom":"","left":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"large":"","icon":""}},on),[_vm._t("button")],2)]}}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }